import { CardSkeleton } from "./cardSkeleton"

interface LoadingCardProps {
  loading: boolean
  children: React.ReactNode
}

export function LoadingCard({ loading, children }: LoadingCardProps) {
  if (loading) return <CardSkeleton />
  return <>{children}</>
}
